export default {"src":"/_next/static/media/icon-search-s.37eda221.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};